export const MIN_SEARCH_CHARS = 3;
